import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=f8cb2ef0&scoped=true&lang=pug&"
import script from "./ImagePopup.vue?vue&type=script&lang=js&"
export * from "./ImagePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImagePopup.vue?vue&type=style&index=0&id=f8cb2ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cb2ef0",
  null
  
)

export default component.exports